const DEFAULT_MONTH = new Date().getMonth() + 1;

const normalizeMonth = (month?: number | string) => {
  const monthNumber = Number(month);

  if (Number.isNaN(monthNumber) || monthNumber < 1 || monthNumber > 12) {
    return DEFAULT_MONTH;
  }

  return monthNumber;
};

export const resolveCssColor = (color: string): string => {
  const varMatch = color.match(/var\((--[^)]+)\)/);
  if (!varMatch) {
    return color;
  }

  const cssVar = varMatch[1];
  const resolved = getComputedStyle(document.documentElement)
    .getPropertyValue(cssVar)
    .trim();
  return resolved || color;
};

export const getMonthGradient = (month?: number | string): string => {
  const monthNumber = normalizeMonth(month);
  const accentMonth = monthNumber < 12 ? monthNumber + 1 : monthNumber;

  return `linear-gradient(to bottom, var(--${monthNumber}-secondary), var(--${accentMonth}-secondary))`;
};

export const getMonthGraffitiColor = (month?: number | string): string => {
  const monthNumber = normalizeMonth(month);
  return `var(--${monthNumber}-principal)`;
};

export const getBackgroundFallbackColor = (background: string): string => {
  const cssVarMatches = Array.from(background.matchAll(/var\((--[^)]+)\)/g));

  if (cssVarMatches.length > 0) {
    const lastCssVar = cssVarMatches[cssVarMatches.length - 1][1];
    return resolveCssColor(`var(${lastCssVar})`);
  }

  const colorStops = background
    .replace(/^linear-gradient\(/, '')
    .replace(/\)$/, '')
    .split(',')
    .map((part) => part.trim());

  return resolveCssColor(colorStops[colorStops.length - 1] || background);
};

const syncThemeColorMeta = (color: string) => {
  let meta = document.querySelector<HTMLMetaElement>('meta[name="theme-color"]');

  if (!meta) {
    meta = document.createElement('meta');
    meta.name = 'theme-color';
    document.head.appendChild(meta);
  }

  meta.content = color;
};

export const applyDocumentBackground = (background: string) => {
  const fallbackColor = getBackgroundFallbackColor(background);

  document.documentElement.style.setProperty('--default-background', background);
  document.documentElement.style.setProperty('--active-background', background);
  document.documentElement.style.setProperty(
    '--active-background-color',
    fallbackColor
  );
  document.documentElement.style.background = 'none';
  document.body.style.background = 'none';
  document.documentElement.style.backgroundColor = fallbackColor;
  document.body.style.backgroundColor = fallbackColor;
  syncThemeColorMeta(fallbackColor);
};

export const applyDocumentMonthTheme = (month?: number | string) => {
  const background = getMonthGradient(month);
  const graffitiColor = getMonthGraffitiColor(month);

  applyDocumentBackground(background);
  document.documentElement.style.setProperty(
    '--active-graffiti-color',
    graffitiColor
  );
};
